module.exports = require("@swissquote/crafty-commons/packages/ansi-colors.js");